<script setup lang="ts">
import AdminProjects from './details/AdminProjects.vue';
import AdminUserList from './details/AdminUserList.vue';

const props = defineProps<{
  projectId: string | null;
  fortnoxId: string | null;
  isArchived: boolean | null;
}>();

const emit = defineEmits<{
  (e: 'reloadProjects'): void;
}>();

const handleReloadProjects = () => {
  emit('reloadProjects');
};
</script>

<template>
  <div class="project-box">
    <AdminProjects
      :projectId="props.projectId"
      :fortnoxId="props.fortnoxId"
      :isArchived="props.isArchived"
      @reloadProjects="handleReloadProjects"
    />
    <hr class="strong-hr" />
    <AdminUserList
      :projectId="props.projectId"
      :fortnoxId="props.fortnoxId"
      :isArchived="props.isArchived"
    />
  </div>
</template>

<style scoped lang="scss">
.project-box {
  background-color: var(--admin-projects-project-box);
  width: 100%;
  min-height: 40rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1rem;
  border-radius: 4px;
  border: 2px solid #c0d4f7;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  position: relative;
}

.strong-hr {
  border: none;
  height: 2px;
  width: 100%;
  background-color: #c0d4f7;
  margin: 1rem 0;
}
</style>
